import { LogLevel } from "@azure/msal-browser";

// Deve corrispondere a un Redirect URI registrato nell'app Azure AD (root dell'app):
// l'elaborazione della risposta di redirect avviene a livello di App.js,
// indipendentemente dalla route su cui atterra.
const redirectUri = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENTID,
    authority: process.env.REACT_APP_MSAL_AUTORITY,
    redirectUri: redirectUri, // Usa l'origine della pagina per maggiore coerenza
    postLogoutRedirectUri: redirectUri, // Aggiungi l'URI di reindirizzamento dopo il logout
    navigateToLoginRequestUrl: false, // Manteniamo false come era in precedenza
    // Impostazioni popup migliorate
    popupWindowAttributes: {
      popupSize: { width: 640, height: 600 },
      popupPosition: { top: 100, left: 100 },
    },
  },
  cache: {
    cacheLocation: "sessionStorage", // Usa sessionStorage come prima
    storeAuthStateInCookie: true, // Cambiato a true per una migliore compatibilità cross-browser
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error("[MSAL]", message);
            return;
          case LogLevel.Warning:
            console.warn("[MSAL]", message);
            return;
          case LogLevel.Info:
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Verbose, // Aumentato il livello per avere più dettagli durante il debug
      piiLoggingEnabled: false,
    },
    // Aggiunte queste impostazioni per migliorare la gestione dei token
    tokenRenewalOffsetSeconds: 300, // Rinnova i token 5 minuti prima della scadenza
    iframeHashTimeout: 6000, // Aumenta il timeout per l'elaborazione del hash
  },
};

export const loginRequest = {
  scopes: ["User.Read", "GroupMember.Read.All"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

// Funzione di utilità per gestire la pulizia dello storage
export const clearMsalCache = () => {
  // Rimuovi tutti gli elementi MSAL da sessionStorage
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith("msal.") ||
      key.includes("login") ||
      key.includes("redirect")
    ) {
      sessionStorage.removeItem(key);
    }
  });

  // Rimuovi tutti gli elementi MSAL da localStorage (alcuni browser potrebbero usarlo)
  Object.keys(localStorage).forEach((key) => {
    if (
      key.startsWith("msal.") ||
      key.includes("login") ||
      key.includes("redirect")
    ) {
      localStorage.removeItem(key);
    }
  });

  // Rimuovi tutti i cookie correlati a MSAL
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

    if (
      name.startsWith("msal.") ||
      name.includes("auth") ||
      name.includes("login")
    ) {
      document.cookie =
        name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }

  // Rimuovi le variabili di stato della sessione
  sessionStorage.removeItem("redirectComplete");
  sessionStorage.removeItem("loginRedirect");
  sessionStorage.removeItem("forceNewLogin");
};
